type IconProps = {
  name: string;
  size?: number;
  stroke?: number;
  className?: string;
};

export function Icon({ name, size = 16, stroke = 1.7, className }: IconProps) {
  const s = { width: size, height: size, flexShrink: 0 as const };
  const p = {
    fill: "none" as const,
    stroke: "currentColor",
    strokeWidth: stroke,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  };
  const svg = (children: React.ReactNode) => (
    <svg viewBox="0 0 24 24" style={s} className={className} aria-hidden>
      <g {...p}>{children}</g>
    </svg>
  );

  switch (name) {
    case "dashboard":
      return svg(<><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></>);
    case "sites":
    case "globe":
      return svg(<><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18"/></>);
    case "alert":
      return svg(<><path d="M12 3l9.5 16.5H2.5z"/><path d="M12 10v4M12 17.5v.01"/></>);
    case "shield":
      return svg(<><path d="M12 3l8 3v6c0 5-3.5 8.5-8 9.5-4.5-1-8-4.5-8-9.5V6z"/><path d="M9 12l2 2 4-4"/></>);
    case "gauge":
      return svg(<><path d="M3 18a9 9 0 1118 0"/><path d="M12 18l4.5-6"/></>);
    case "puzzle":
      return svg(<path d="M9 3v3h-3v4a2 2 0 002 2 2 2 0 010 4H6v5h5a2 2 0 002-2 2 2 0 014 0 2 2 0 002 2h2v-5h-2a2 2 0 010-4 2 2 0 002-2V6h-5V3"/>);
    case "archive":
      return svg(<><rect x="3" y="4" width="18" height="4"/><path d="M5 8v12h14V8M10 12h4"/></>);
    case "users":
      return svg(<><circle cx="9" cy="8" r="3.5"/><circle cx="17" cy="9" r="2.5"/><path d="M3 19c0-3.5 2.5-5.5 6-5.5s6 2 6 5.5M15 19c0-2.5 1.5-4 4-4s4 1.5 4 4"/></>);
    case "cog":
      return svg(<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1A1.7 1.7 0 008 19.4a1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H2a2 2 0 110-4h.1A1.7 1.7 0 003.6 8a1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H8a1.7 1.7 0 001-1.5V2a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V8a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z"/></>);
    case "arrow-up":
      return svg(<><path d="M12 19V5M5 12l7-7 7 7"/></>);
    case "arrow-down":
      return svg(<><path d="M12 5v14M19 12l-7 7-7-7"/></>);
    case "arrow-right":
      return svg(<><path d="M5 12h14M12 5l7 7-7 7"/></>);
    case "check":
      return svg(<path d="M4 12l5 5 11-11"/>);
    case "x":
      return svg(<><path d="M6 6l12 12M18 6L6 18"/></>);
    case "search":
      return svg(<><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.5-4.5"/></>);
    case "filter":
      return svg(<path d="M3 5h18l-7 9v6l-4-2v-4z"/>);
    case "plus":
      return svg(<><path d="M12 5v14M5 12h14"/></>);
    case "more":
      return svg(<><circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/></>);
    case "bell":
      return svg(<><path d="M6 8a6 6 0 1112 0c0 7 3 8 3 8H3s3-1 3-8M10 21a2 2 0 004 0"/></>);
    case "chevron-right":
      return svg(<path d="M9 6l6 6-6 6"/>);
    case "chevron-down":
      return svg(<path d="M6 9l6 6 6-6"/>);
    case "wp":
      return svg(<><circle cx="12" cy="12" r="9"/><path d="M5 9l3 9 2.5-7M9 9l3 9 1.5-4.5L15 9M5.5 9h13"/></>);
    case "database":
      return svg(<><ellipse cx="12" cy="5" rx="8" ry="2.5"/><path d="M4 5v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5V5M4 11v6c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5v-6"/></>);
    case "sparkle":
      return svg(<><path d="M12 3l1.6 5.4L19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6zM19 17l.7 2.3L22 20l-2.3.7L19 23l-.7-2.3L16 20l2.3-.7z"/></>);
    case "zap":
      return svg(<path d="M13 2L3 14h7l-1 8 10-12h-7z"/>);
    case "clock":
      return svg(<><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>);
    case "eye":
      return svg(<><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></>);
    case "lock":
      return svg(<><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></>);
    case "mail":
      return svg(<><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></>);
    case "wa":
      return svg(<><path d="M3 21l1.6-5A8 8 0 1119 19l-5 1.6"/><path d="M8.5 9c0 3 2.5 5.5 5.5 5.5l1-1 2.5 1.5-1 2c-3.5.5-8-3-8.5-7l2-1z" fill="currentColor"/></>);
    case "log":
      return svg(<><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></>);
    case "download":
      return svg(<><path d="M12 3v12M6 11l6 6 6-6M4 21h16"/></>);
    case "refresh":
      return svg(<><path d="M3 12a9 9 0 0115-6.7L21 8M21 3v5h-5M21 12a9 9 0 01-15 6.7L3 16M3 21v-5h5"/></>);
    case "sun":
      return svg(<><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></>);
    case "moon":
      return svg(<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>);
    case "logout":
      return svg(<><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></>);
    case "domains":
      return svg(<><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></>);
    case "hosting":
      return svg(<><rect x="2" y="3" width="20" height="5" rx="1"/><rect x="2" y="10" width="20" height="5" rx="1"/><rect x="2" y="17" width="20" height="4" rx="1"/><circle cx="6" cy="5.5" r="1" fill="currentColor" stroke="none"/><circle cx="6" cy="12.5" r="1" fill="currentColor" stroke="none"/></>);
    case "expiry":
      return svg(<><circle cx="12" cy="12" r="9"/><path d="M12 8v4l3 2M8.5 20.5l-1.5 1.5M15.5 20.5l1.5 1.5"/></>);
    case "import":
      return svg(<><path d="M3 15v4a2 2 0 002 2h14a2 2 0 002-2v-4M12 3v12M7 8l5-5 5 5"/></>);
    case "audit":
      return svg(<><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 7h8M8 11h8M8 15h5"/><path d="M16 15l2 2 3-3"/></>);
    case "activity":
    case "pulse":
      // Heartbeat / EKG line — usado pela página /health.
      return svg(<path d="M3 12h4l2-7 4 14 2-5 2 2h4"/>);
    default:
      return svg(<circle cx="12" cy="12" r="9"/>);
  }
}
